





































































import Users from '../../model/Users';

export default {
	name: 'Profile',
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		const validatePass: Function = (rule, value, callback) => {
			value !== this.passwordForm.new ? callback(new Error('error')) : callback();
		};
		return {
			form: {
				firstName: '',
				lastName: '',
				email: '',
			},
			loading: false,
			formLabelWidth: '120px',
			passwordDrawer: false,
			passwordForm: {
				current: '',
				new: '',
				check: '',
			},
			rulesPass: {
				current: [
					{ required: true, message: this.$t('profile.validation.currentPasswordRequired'), trigger: 'blur' },
					{ min: 6, message: this.$t('profile.validation.passwordMin'), trigger: 'blur' },
				],
				new: [
					{ required: true, message: this.$t('profile.validation.newPasswordRequired'), trigger: 'blur' },
					{ min: 6, message: this.$t('profile.validation.passwordMin'), trigger: 'blur' },
				],
				check: [
					{ required: true, message: this.$t('profile.validation.confirmNewRequired'), trigger: 'blur' },
					{
						validator: validatePass,
						message: this.$t('profile.validation.newPasswordsDoNotMatch'),
						trigger: ['blur', 'change'],
					},
				],
			},
			rules: {
				firstName: [{ required: true, message: this.$t('profile.validation.firstNameRequired'), trigger: 'blur' }],
				lastName: [{ required: true, message: this.$t('profile.validation.lastNameRequired'), trigger: 'blur' }],
				email: [
					{ required: true, message: this.$t('profile.validation.emailRequired'), trigger: 'blur' },
					{ type: 'email', message: this.$t('profile.validation.emailInvalid'), trigger: ['blur', 'change'] },
				],
			},
		};
	},
	computed: {
		user(): Users {
			return this.$store.getters.currentUser;
		},
	},
	watch: {
		visible(newValue, oldValue) {
			if (newValue === oldValue) return;
			this.form = {
				firstName: this.user.firstName,
				lastName: this.user.lastName,
				email: this.user.email,
			};
		},
	},
	methods: {
		async validateForm(id): Promise<boolean> {
			try {
				return await this.$refs[id].validate();
			} catch (error) {
				return false;
			}
		},
		onCloseDrawer(): boolean {
			this.$emit('before-close');
			this.form = this.$options.data.call(this).form;
			return true;
		},
		onClosePasswordDrawer(): boolean {
			this.passwordForm = this.$options.data.call(this).passwordForm;
			this.passwordDrawer = false;
			return true;
		},
		async onSave(): Promise<void> {
			let differentData = false;

			['firstName', 'lastName', 'email'].forEach(key => this.user[key] !== this.form[key] && (differentData = true));

			if (!differentData) return this.$refs.profileDrawer.closeDrawer();

			const valid = await this.validateForm('userForm');

			if (!valid) return;
			this.loading = true;

			const data = { path: this.$store.getters.path, user: { ...this.user, ...this.form } };

			try {
				const response = await this.$firebase.functions().httpsCallable('editUser')(data);
				this.loading = false;
				this.$refs.profileDrawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('profile.userEdited'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: error,
				});
			}
		},
		async onPasswordChange(): Promise<void> {
			const valid = await this.validateForm('passwordForm');
			if (!valid) return;
			const data = {
				uid: this.$store.state.user.uid,
				tenantId: this.$store.state.user.tenantId,
				pass: this.passwordForm.new,
			};
			try {
				this.loading = true;
				const cred = this.$firebase.auth.EmailAuthProvider.credential(this.user.email, this.passwordForm.current);
				await this.$firebase.auth().currentUser.reauthenticateWithCredential(cred);
				const response = await this.$firebase.functions().httpsCallable('changePassword')(data);
				this.loading = false;
				this.$refs.profileDrawer.closeDrawer();
				this.$refs.passwordDrawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('profile.passwordChanged'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);
				this.$message({
					type: 'error',
					message: error.code === 'auth/wrong-password' ? 'Wrong password' : error.message,
				});
			}
		},
	},
	mounted() {},
};
